import type { ReactNode } from "react";

interface SectionHeadingProps {
  kicker: string;
  title: string;
  desc?: string;
  action?: ReactNode;
}

export default function SectionHeading({ kicker, title, desc, action }: SectionHeadingProps) {
  return (
    <div className="mb-8 flex flex-col gap-4 border-b border-background-200 pb-5 sm:flex-row sm:items-end sm:justify-between">
      <div>
        <p className="flex items-center gap-2 text-xs font-medium tracking-[0.2em] text-primary-600">
          <span className="h-1 w-6 bg-primary-500"></span>
          {kicker}
        </p>
        <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
          {title}
        </h2>
        {desc && <p className="mt-2 max-w-2xl text-sm text-foreground-600">{desc}</p>}
      </div>
      {action}
    </div>
  );
}